
const config = {
    api_version: 'v1',
    data_platform_api_url: process.env.REACT_APP_DATAPLATFORM_BACKEND_SDK_URL || `${window.location.origin}/api/v1`
}

export default config;